import {Injectable} from '@angular/core';
import {URLSearchParams, Headers} from '@angular/http';
import {CookieService} from 'ngx-cookie';
import {SessionService} from "./session.service";
import {httpExtensionService} from "./httpextension.service";
import {ConfigService} from "../../config/config.service";
import {SettingsService} from "./settings.service";

@Injectable()
export class CommonDataService {

    unsavedChanges: boolean = false;
    setUnsavedChanges(value) {
        this.unsavedChanges = value
    };

    genders: Array<string> = ['male', 'female'];

    // months array
    months: Array<string> = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'FeDecemberbruary'
    ];

    monthsShort: Array<string> = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];

    weekForCharts = {
        'MONDAY': 0,
        'TUESDAY': 0,
        'WEDNESDAY': 0,
        'THURSDAY': 0,
        'FRIDAY': 0,
        'SATURDAY': 0,
        'SUNDAY': 0
    };

    activeMarketsFilterObject: any = {
        paging: {
            page: 1,
            numRows: 0
        },
        filter: {
            fields: [{
                field: "status",
                value: "ACTIVE",
                operation: "EQUAL"
            }]
        }
    };

    allMarketsFilterObject: any = {
        paging: {
            page: 1,
            numRows: 0
        }
    };

    activeMarkets: any[] = [];
    allMarkets: any[] = [];
    allCategories: any[] = [];

    setActiveMarkets(activeMarkets) {
        this.activeMarkets = activeMarkets;
    }

    setAllMarkets(allMarkets) {
        this.allMarkets = allMarkets;
    }

    modifyToSelectItems(markets) {
        let selectItems = [];
        markets.forEach(market => {
            let marketName = '';
            if (market.name == 'SANTA_BARBARA_MARKET') {
                marketName = "Santa Barbara";
            } else if (market.name == 'VENTURA_MARKET') {
                marketName = "Ventura";
            } else {
                marketName = market.name;
            }
            selectItems.push({
                label: ' ' + marketName,
                value: market.name,
                id: market.id,
                status: market.status
            });
        });
        selectItems.sort(this.sortValuesAlphabetically);
        return selectItems;
    }

    sortValuesAlphabetically(a, b) {
        if (a.value < b.value)
            return -1;
        if (a.value > b.value)
            return 1;
        return 0;
    }

    ageCategories = {
        BETWEEN_18_30: 0,
        BETWEEN_31_45: 0,
        OVER_45: 0,
        UNDER_18: 0
    };

    incomesCategories = {
        LESS_50000: 0,
        BETWEEN_50000_70000: 0,
        BETWEEN_75000_10000: 0,
        BETWEEN_100000_150000: 0,
        BETWEEN_150000_200000: 0,
        OVER_200000: 0,
    };

    cities: string[] = ['Santa Barbara',
        'Goleta',
        'Carpinteria',
        'Solvang',
        'Santa Ynez',
        'Los Olivos',
        'Buellton',
        'Ventura',
        'Camarillo',
        'Ojai',
        'Oxnard',
        'Newbury Park',
        'Thousand Oaks'];

    statusesDropdown = [
        {
            val: 'AwaitingPayment',
            label: 'Awaiting Additional Information'
        },
        {
            val: 'Pending',
            label: 'Pending'
        },
        {
            val: 'InProduction',
            label: 'In Production'
        },
        {
            val: 'ReadyForPickup',
            label: 'Ready For Pickup'
        },
        {
            val: 'PartiallyShipped',
            label: 'Partially Shipped'
        },
        {
            val: 'Shipped',
            label: 'Shipped'
        },
        {
            val: 'Completed',
            label: 'Completed'
        },
        {
            val: 'Canceled',
            label: 'Canceled'
        },
        {
            val: 'ShippedReadyForPickup',
            label: 'Accounting'
        }

    ];
    hoursArr: any[] = ['HH', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    minutesArr: any[] = ['MM', '00', '15', '30', '45'];
    timeArr: string[] = ['AM', 'PM'];

    constructor(private _cookieService: CookieService, private sessionService: SessionService,
                private http: httpExtensionService, private config: ConfigService,
                private settingsService: SettingsService) {
        this.allMarkets = [];
        this.activeMarkets = [];
    }

    refreshView() {
        let body = {};
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.refreshView , body, {
            headers: headers
        })
    }

    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }

    loadAllCategories(data, allMarketsCount, filterActive?) {
        let allCategories = [];
        if (filterActive !== undefined && filterActive === true) {
            allCategories = data.categories.filter(item => item.status === 'ACTIVE');
        } else {
            allCategories = data.categories;
        }
        const commonCategories = [];
        const specificCategories = [];
        let sortedCategories = [];
        allCategories.forEach(cat => {
            if (cat.marketNames.length === allMarketsCount) {
                commonCategories.push({
                    label: ' ' + cat.name,
                    value: cat.name,
                    id: cat.id
                });
            } else {
                specificCategories.push({
                    marketsCount: cat.marketNames.length,
                    label: " " + cat.name + (cat.marketNames.length > 0 ? (" (" + this.getMarketNamesAppendix(cat.marketNames) + ")") : ""),
                    value: cat.name,
                    id: cat.id,
                    nameAppendix: cat.marketNames.length > 0 ? this.getMarketNamesAppendix(cat.marketNames) : ""
                });
            }
        });
        commonCategories.sort(this.sortValues);
        if (specificCategories.length > 0) {
            specificCategories.sort(function(a, b) {
                // Descending sort by markets count
                if (a.marketsCount > b.marketsCount) return -1;
                if (a.marketsCount < b.marketsCount) return 1;

                // Descending sort by name appendix
                if (b.nameAppendix < a.nameAppendix) return 1;
                if (b.nameAppendix > a.nameAppendix) return -1;

                // Ascending alphabetical sort
                if (a.value > b.value) return 1;
                if (a.value < b.value) return -1;
            });
        }

        sortedCategories = this.fillAllCategories(sortedCategories, commonCategories);
        sortedCategories = this.fillAllCategories(sortedCategories, specificCategories);

        return sortedCategories;
    }

    getMarketNamesAppendix(names) {
        names.forEach(function (element, index) {
            if (element == 'SANTA_BARBARA_MARKET') {
                this[index] = "Santa Barbara";
            } else if (element == 'VENTURA_MARKET') {
                this[index] = "Ventura";
            }
        }, names);
        return names.join();
    }

    sortValues(a,b) {
        if (a.value < b.value)
            return -1;
        if (a.value > b.value)
            return 1;
        return 0;
    }

    sortNames(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase())
            return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase())
            return 1;
        return 0;
    }

    fillCategories(sortedCategories, loadCategories) {
        for(let i = 0; i < loadCategories.length; i++) {
            sortedCategories.push({ label: ' ' + loadCategories[i].label, value: loadCategories[i].value });
        }
        return sortedCategories;
    }

    fillAllCategories(sortedCategories, loadCategories) {
        for (let i = 0; i < loadCategories.length; i++) {
            sortedCategories.push({
                label: ' ' + loadCategories[i].label,
                value: loadCategories[i].value,
                id: loadCategories[i].id
            });
        }
        return sortedCategories;
    }

    formatNumbersWithComas(inputNumber) {
        let parts = inputNumber.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    // get range of years from starting year
    iterateBDayYears(startDate): Array<number> {
        let years: Array<number> = [];
        for (let i = startDate; i <= new Date().getFullYear(); i++) {
            years.push(i);
        }
        return years;
    }

    trimSpasesBeginningEnding(input) {
        while (input.startsWith(' ')) {
            input = input.substr(1);
        }
        while (input.endsWith(' ')) {
            input = input.substr(0, input.length - 1);
        }
        return input;
    }

    trimObjectData(item) {
        for (let i in item) {
            if (item.hasOwnProperty(i) && item[i] != '' && item[i] != null && item[i] != undefined && i != 'password' && i != 'rePassword') {
                if (item[i].replace) {
                    item[i] = item[i].replace(/\s+/g, ' ');
                }
                if (item[i].trim) {
                    item[i] = item[i].trim();
                }
            }
        }

        return item;
    }

    deleteEmptyObjectProperties(item) {
        for (let i in item) {
            if (item.hasOwnProperty(i) && (item[i] == '' || item[i] == null || item[i] == undefined)) {
                delete item[i];
            }
        }

        return item;
    }

    uploadFile(fileToUpload: any) {
        let input = new FormData();
        input.append('file', fileToUpload);

        return input;
    }

    ///used for admin -> merchant -> edot/new -> locations -> edit/new ==> hours of operations
    hooObjectTemplate: any[] = [
        {
            'd': 'Monday',
            'e': true,
            's1': undefined,
            'e1': undefined,
            's2': undefined,
            'e2': undefined
        },
        {
            'd': 'Tuesday',
            'e': true,
            's1': undefined,
            'e1': undefined,
            's2': undefined,
            'e2': undefined
        },
        {
            'd': 'Wednesday',
            'e': true,
            's1': undefined,
            'e1': undefined,
            's2': undefined,
            'e2': undefined
        },
        {
            'd': 'Thursday',
            'e': true,
            's1': undefined,
            'e1': undefined,
            's2': undefined,
            'e2': undefined
        },
        {
            'd': 'Friday',
            'e': true,
            's1': undefined,
            'e1': undefined,
            's2': undefined,
            'e2': undefined
        },
        {
            'd': 'Saturday',
            'e': true,
            's1': undefined,
            'e1': undefined,
            's2': undefined,
            'e2': undefined
        },
        {
            'd': 'Sunday',
            'e': true,
            's1': undefined,
            'e1': undefined,
            's2': undefined,
            'e2': undefined
        }
    ];

    urlDataDecoded(data) {
        let searchParams = new URLSearchParams();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                searchParams.set(key, data[key] + '');
            }
        }
        return searchParams.toString();
    }

    // JSON to CSV
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

        var CSV = '';
        //Set Report title in first row or line

        CSV += ReportTitle + '\r\n\n';

        //This condition will generate the Label/Header
        if (ShowLabel) {
            var row = "";

            //This loop will extract the label from 1st index of on array
            for (var index in arrData[0]) {

                //Now convert each value to string and comma-seprated
                row += index + ',';
            }

            row = row.slice(0, -1);

            //append Label row with line break
            CSV += row + '\r\n';
        }

        //1st loop is to extract each row
        for (var i = 0; i < arrData.length; i++) {
            var row = "";

            //2nd loop will extract each column and convert it in string comma-seprated
            for (var index in arrData[i]) {
                row += '"' + arrData[i][index] + '",';
            }

            row.slice(0, row.length - 1);

            //add a line break after each row
            CSV += row + '\r\n';
        }

        if (CSV == '') {
            alert("Invalid data");
            return;
        }

        //Generate a file name
        var fileName = "MyReport_";
        //this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, "_");

        //Initialize file format you want csv or xls
        var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(CSV);

        // Now the little tricky part.
        // you can use either>> window.open(uri);
        // but this will not work in some browsers
        // or you will not get the correct file extension

        //this trick will generate a temp <a /> tag
        var link = document.createElement("a");
        link.href = uri;

        //set the visibility hidden so it will not effect on your web-layout
        //link.style = "visibility:hidden";
        link.download = fileName + ".csv";

        //this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    //The number of delay for automatic filter is approximately 24 days
    dataTableFilterDelay = 2147483647;

    annualHouseholdIncome = [
        {label: 'Less than $50,000', value: 'LESS_50000'},
        {label: '$50,000 - $75,000', value: 'BETWEEN_50000_70000'},
        {label: '$75,000 - $100,000', value: 'BETWEEN_75000_10000'},
        {label: '$100,000 - $150,000', value: 'BETWEEN_100000_150000'},
        {label: '$150,000 - $200,000', value: 'BETWEEN_150000_200000'},
        {label: 'Over $200,000', value: 'OVER_200000'},
    ];

    homeOwner = [
        {label: 'Own', value: 'OWN'},
        {label: 'Rent', value: 'RENT'}
    ];

    householdMembers = [
        {label: '1', value: 'ONE'},
        {label: '2', value: 'TWO'},
        {label: '3', value: 'THREE'},
        {label: '4', value: 'FOUR'},
        {label: '5', value: 'FIVE'},
        {label: '6+', value: 'MORE_THAN_6'}
    ];

    states = [
        {value: 'AL', label: 'Alabama'},
        {value: 'AK', label: 'Alaska'},
        {value: 'AZ', label: 'Arizona'},
        {value: 'AR', label: 'Arkansas'},
        {value: 'CA', label: 'California'},
        {value: 'CO', label: 'Colorado'},
        {value: 'CT', label: 'Connecticut'},
        {value: 'DE', label: 'Delaware'},
        {value: 'DC', label: 'District Of Columbia'},
        {value: 'FL', label: 'Florida'},
        {value: 'GA', label: 'Georgia'},
        {value: 'HI', label: 'Hawaii'},
        {value: 'ID', label: 'Idaho'},
        {value: 'IL', label: 'Illinois'},
        {value: 'IN', label: 'Indiana'},
        {value: 'IA', label: 'Iowa'},
        {value: 'KS', label: 'Kansas'},
        {value: 'KY', label: 'Kentucky'},
        {value: 'LA', label: 'Louisiana'},
        {value: 'ME', label: 'Maine'},
        {value: 'MD', label: 'Maryland'},
        {value: 'MA', label: 'Massachusetts'},
        {value: 'MI', label: 'Michigan'},
        {value: 'MN', label: 'Minnesota'},
        {value: 'MS', label: 'Mississippi'},
        {value: 'MO', label: 'Missouri'},
        {value: 'MT', label: 'Montana'},
        {value: 'NE', label: 'Nebraska'},
        {value: 'NV', label: 'Nevada'},
        {value: 'NH', label: 'New Hampshire'},
        {value: 'NJ', label: 'New Jersey'},
        {value: 'NM', label: 'New Mexico'},
        {value: 'NY', label: 'New York'},
        {value: 'NC', label: 'North Carolina'},
        {value: 'ND', label: 'North Dakota'},
        {value: 'OH', label: 'Ohio'},
        {value: 'OK', label: 'Oklahoma'},
        {value: 'OR', label: 'Oregon'},
        {value: 'PA', label: 'Pennsylvania'},
        {value: 'RI', label: 'Rhode Island'},
        {value: 'SC', label: 'South Carolina'},
        {value: 'SD', label: 'South Dakota'},
        {value: 'TN', label: 'Tennessee'},
        {value: 'TX', label: 'Texas'},
        {value: 'UT', label: 'Utah'},
        {value: 'VT', label: 'Vermont'},
        {value: 'VA', label: 'Virginia'},
        {value: 'WA', label: 'Washington'},
        {value: 'WV', label: 'West Virginia'},
        {value: 'WI', label: 'Wisconsin'},
        {value: 'WY', label: 'Wyoming'}
    ];

    formatDollarAmount(n, currency) {
        return currency + " " + n.toFixed(2).replace(/./g, function (c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
            });
    }

    formatPhone(event, phone, input) {
        if (event.key != 'Tab') {
            let tmp = '';
            for (let i = 0; i < phone.length; i++) {
                if (phone[i] >= '0' && phone[i] <= '9') {
                    tmp += phone[i];
                }
            }
            if (!tmp) {
                phone = input = '';
                return input;
            }
            if (tmp.length < 3) {
                phone = input = '(' + tmp;
                return input;
            }

            phone = '(' + tmp.substr(0, 3);
            tmp = tmp.substr(3);

            if (tmp.length) {
                phone += ') ';
            }
            for (let i = 0; i < tmp.length; i++) {
                if (i < 3) {
                    //console.log('1', tmp.substring(i, i + 1));
                    phone += tmp.substring(i, i + 1);
                } else if (i % 4 === 3) {
                    phone += '-';
                    //console.log('2', tmp.substring(i, i + 1));
                    phone += tmp.substring(i, i + 1);
                } else {
                    //console.log('3', tmp.substring(i, i + 1));
                    phone += tmp.substring(i, i + 1);
                }
            }
            input = phone;
        }
        return input;
    }

    barOptions = {
        legend: {
            position: 'left',
            labels: {
                boxWidth: 13
            }
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItems, data) {
                    return data.labels[tooltipItems.index].split(':')[0] + ': ' + data.datasets[0].data[tooltipItems.index];
                }
            }
        }
    }

    addCache(cname, cvalue, time) {
        let cookieExpiry: number = Date.now() + time * 1000;
        return this._cookieService.put(cname, cvalue, {expires: new Date(cookieExpiry)});
    }

    getCache(cname) {
        return this._cookieService.get(cname);
    }

    remCache(cname) {
        return this._cookieService.remove(cname);
    }

    reverseBuildQuerryObjectFromResponse(resp) {
        if (!resp || !resp.paging) {
            return {};
        }
        let obj: any = {
            "paging": {
                "page": resp.paging.page,
                "numRows": resp.paging.numRows
            }
        };
        if (resp.sorting && resp.sorting.length) {
            obj.sorting = [];
            for (let i = 0; i < resp.sorting.length; i++) {
                obj.sorting.push({
                    'property': resp.sorting[i].property,
                    'direction': resp.sorting[i].direction
                });
            }
            ;
        }
        if (resp.filter && resp.filter.fields && resp.filter.fields.length) {
            obj.filter = obj.filter || {};
            obj.filter.fields = obj.filter.fields || [];
            for (let i = 0; i < resp.filter.fields.length; i++) {
                if ('BETWEEN_DATES' === resp.filter.fields[i].operation) {
                    obj.filter.fields.push({
                        "operation": "BETWEEN_DATES",
                        "field": resp.filter.fields[i].field,
                        "value": resp.filter.fields[i].value,
                        "fromDate": this.formatDateWithHiphens(resp.filter.fields[i].fromDate),
                        "toDate": this.formatDateWithHiphens(resp.filter.fields[i].toDate)
                        // "fromDate": resp.filter.fields[i].fromDate,
                        // "toDate": resp.filter.fields[i].toDate
                    });
                } else {
                    obj.filter.fields.push({
                        'field': resp.filter.fields[i].field,
                        'value': resp.filter.fields[i].value,
                        'operation': resp.filter.fields[i].operation
                    });
                }
            }
        }
        if (resp.filter.globalSearch) {
            obj.filter = obj.filter || {};
            obj.filter.globalSearch = resp.filter.globalSearch;
        }
        //debugger;
        //obj.filter.globalSearch = this.global;
        //console.log(obj);
        return obj;
    }

    isValidPhone(phone) {
        //under 6  - not saving all valid
        if (phone.length < 6) {
            return true;
        }

        //the length is not valid - we dont care about the symbols
        if (phone.length < 9) {
            return false;
        }

        //validate first digits
        if (phone[0] != '(' || phone[4] != ')' ||
            (phone[1] < '0' || phone[1] > '9') ||
            (phone[2] < '0' || phone[2] > '9') ||
            (phone[3] < '0' || phone[3] > '9')) {
            return false
        }

        //validate after the code
        for (let i = 6; i < phone.length; i++) {
            if (phone[i] < '0' || phone[i] > '9') {
                if (phone[i] !== ' ' && phone[i] !== '-') {
                    return false;
                }
            }
        }
        return true;
    }

    formatDateWithHiphens(date) {
        let year = Number(date.substr(0, 4));
        let month = !date.substr(5, 2).startsWith('0') ? date.substr(5, 2) : date.substr(6, 1);
        let day = !date.substr(8, 2).startsWith('0') ? date.substr(8, 2) : date.substr(9, 1);
        return year + '-' + month + '-' + day;
    }

    formatDate(date) {
        //MM/DD/YY
        return Number(date.substr(5, 2)) + '/' + Number(date.substr(8, 2)) + '/' + date.substr(0, 4);
    }

    sortLocationsByActive(arr) {
        if (!arr.length) {
            return [];
        }
        let active = [];
        let inactive = [];
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].active) {
                active.push(arr[i]);
            } else {
                inactive.push(arr[i]);
            }
        }
        return active.concat(inactive);
    }

    sortProductsByActive(arr) {
        if (!arr.length) {
            return [];
        }
        let active = [];
        let inactive = [];
        for (let i = 0; i < arr.length; i++) {
            if ('ENABLED' === arr[i].status) {
                active.push(arr[i]);
            } else {
                inactive.push(arr[i]);
            }
        }
        active = this.bubbleSortProductsByStartDate(active, 'startDate');
        inactive = this.bubbleSortProductsByStartDate(inactive, 'startDate');
        return active.concat(inactive);
    }

    //if for some unknown reason products become a lot please replace with quick
    bubbleSortProductsByStartDate(arr, prop) {
        let length = arr.length;
        let tmp;
        for (let i = 0; i < length; i++) {
            for (let j = 0; j < (length - i - 1); j++) {
                // we make many date objects but we have to somehow compare dates not strings
                if ((new Date(arr[j][prop])) < (new Date(arr[j + 1][prop]))) {
                    tmp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = tmp;
                }
            }
        }
        return arr;
    }

    sortEmployees(arr) {
        if (!arr.length) {
            return [];
        }
        let active = [];
        let inactive = [];
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].enabled) {
                active.push(arr[i]);
            } else {
                inactive.push(arr[i]);
            }
        }
        active = this.bubbleSortProductsByStartDate(active, 'created');
        inactive = this.bubbleSortProductsByStartDate(inactive, 'created');
        return active.concat(inactive);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/common-data.service.ts